<template>
  <div class="box11-page">
    <div class="top"></div>
    <div class="cont-box">
      <div class="fcp-title">专属高薪岗位推荐服务</div>
      <div class="fcp-text">在博学谷学习培训课程且通过认证的同学，可享受内部专属高薪<br/>岗位推荐服务，多行业、多领域、不可错过的就业内推机会</div>
      <div class="pic-logo"></div>
      <!-- <div class="img-mask">
        <vue-seamless-scroll
          :data="tabList"
          :class-option="classOption1"
          class="img-mask-scroll"
        >
          <div class="img-box" ref="ImgBox">
            <i class="img-1"></i>
            <i class="img-1"></i>
          </div>
        </vue-seamless-scroll>
      </div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        tabList:[1,2]
      }
    },
    computed: {
      classOption1() {
        return {
          step: 0.5, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: false, // 是否开启鼠标悬停stop
          direction: 2, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
  }
</script>

<style lang="scss" scoped>
  .box11-page {
    .top{
      height: 280px;
      background-image: url(../../../assets/coursePage/fcp/box11/box11-top.png);
      background-size: 100% 100%;
    }
    .cont-box{
      margin-top: -120px;
      height: 654px;
      background-image: url(../../../assets/coursePage/fcp/box11/box11-cont-bg2.png);
      background-size: 100% 100%;
      padding-top: 80px;
      box-sizing: border-box;
    }

    .pic-logo{
      width: 692px;
      height: 318px;
      margin: 32px auto 0;
      background-image: url(../../../assets/coursePage/fcp/box11/pic-logo.png);
      background-size: 100% 100%;
    }


    .img-mask {
      position: relative;
      width: 100%;
      height: 432px;
      margin-top: 48px;
      .img-mask-scroll{
        width: 100%;
        height: 432px;
        overflow: hidden;
      }
      .img-box {
        height: 432px;
        display: flex;
        i {
          min-width: 1648px;
          width: 1648px;
          height: 432px;
          background-image: url(../../../assets/coursePage/fcp/box11/box11-logo.png);
          background-size: 100%;
          background-position: center;
          margin-left: 14px;
          background-repeat: no-repeat;
        }
      }
    }
  }
</style>